import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

type Messages = {
	title: MessageDescriptor;
	message: MessageDescriptor;
};

const messages: Messages = defineMessages({
	title: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.error-state.title',
		defaultMessage: 'We couldn’t load the fields',
		description: 'Title displayed when there was en error while searching for fields',
	},
	message: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.error-state.message',
		defaultMessage: 'Clear the search and try again.',
		description: 'Message displayed when there was en error while searching for fields',
	},
});

export default messages;
